import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const conjuntoNacionalBrasilia: ThemeOptions = {
  palette: {
    primary: {
      main: '#009ea1',
    },
    secondary: {
      main: '#f65a02',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#f65a02',
    },
  },
};
